<template>
    <div class="form">
        <form @submit.prevent="nosubmit">
            <slot name="csrf"/>

            <b-message>
                Complete todos los metadatos requieridos y presione 'Guardar'
            </b-message>

            <b-field label="* Titulo"
                     :type="errors.type('title')"
                     :message="errors.get('title')">
                <b-input
                    name="title"
                    type="text"
                    v-model="form.title"
                    @change="bindSlug(form.title)"
                    @input="bindSlug(form.title)"
                    expanded
                />
            </b-field>

            <b-field label="Url">
                <slug-input
                    ref="slug"
                    v-model="form.short_url"
                    prefix="https://pool.apuntmedia.es/"
                    :hide-sync="isEditing"
                    :type="errors.type('short_url')"
                    :message="errors.get('short_url')"
                    name="slug"></slug-input>
            </b-field>

                <b-field label="Canal Brightcove"
                     :type="errors.type('bc_id')"
                     :message="errors.get('bc_id')">
                <async-select
                    :multiple="true"
                    v-model="form.bc_id"
                    data-url="/bcapi/live-list"
                />
            </b-field>

            <b-field label="Long Url" v-if="form.long_url">
                <b-message class="is-link slug-preview">
                    {{ form.long_url }}
                </b-message>
            </b-field>

            <footer class="form-controls">
                <nav class="level">
                    <!-- Left side -->
                    <div class="level-left">
                        <div class="level-item">
                            * Campos Obligatorios
                        </div>
                        <div class="level-item">
                            <b-button tag="a"
                                      href="/shorturls">Cancelar
                            </b-button>
                        </div>
                    </div>

                    <!-- Right side -->
                    <div class="level-right">
                        <p class="level-item">
                            <b-button
                                native-type="button"
                                @click="submitForm"
                                :loading="submitting">Guardar
                            </b-button>
                        </p>
                    </div>
                </nav>
            </footer>
        </form>

    </div>
</template>

<script>
    import Errors from "../../lib/Errors";
    import {Local} from '../../lib/Request';
    import moment from 'moment';
    import SlugInput from "../fields/SlugInput";
    import Summernote from '../../lib/Summernote';
    import VideoIdSelector from "../fields/VideoIdSelector";
    import AsyncSelect from "../fields/AsyncSelect";
    import CalendarInput from "../fields/CalendarInput";

    export default {
        name: "ShortUrlForm",
        components: {SlugInput, AsyncSelect},
        props: {
            csrf: {required: false, default: null},
            action: {required: false, default: null},
            errorMessages: {required: false, default: null},
            values: {required: false, default: null}
        },
        data() {
            return {
                errors: new Errors(),
                submitting: false,
                id: null,
                form: {
                    title: null,
                    short_url: null,
                    bc_id: null,
                    long_url: null
                }
            }
        },
        created() {
            this.errors.setAll(this.errorMessages);

            if (this.values && this.values.id) {
                this.id = this.values.id;

                this.form = {...this.form, ...this.values}
            }
        },
        computed: {
            isEditing() {
                return this.id !== null
            }
        },
        methods: {
            async submitForm() {
                try {
                    this.submitting = true;

                    let formData = new FormData();

                    formData.append('title', this.form.title || '');
                    formData.append('short_url', this.form.short_url || '');
                    formData.append('bc_id', this.form.bc_id || '');
                    formData.append('long_url', this.form.long_url || '');

                    let url = `/shorturls/update`
                    if (this.id) {
                        url = `${url}/${this.id}`
                        formData.append('id', this.id);
                    }

                    let result = await Local.post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                    this.errors.reset();

                    this.$buefy.toast.open({
                        message: 'El url ha sido guardada',
                        type: 'is-success'
                    });

                    this.form.long_url = result.data.values.long_url
                    if (!this.id && result.data.id) {
                        setTimeout(() => {
                            let toks = window.location.href.split('/');
                            toks.push(result.data.id);
                            window.location.href = toks.join('/');
                        }, 2000);
                    } else {
                        this.submitting = false;
                    }
                } catch (error) {
                    this.submitting = false;

                    if (error.response.data && error.response.data.errors) {
                        console.log(error.response.data.errors)
                        this.errors.setAll(error.response.data.errors);
                    }
                    this.$buefy.toast.open({
                        duration: 5000,
                        closable: true,
                        message: 'Hay errores en el formulario',
                        type: 'is-danger'
                    });
                }
            },
            bindSlug(value) {
                if (!this.isEditing) {
                    this.$refs.slug.syncSlug(value)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css";
</style>
